export default "__VITE_ASSET__BEfLfINn__"